/* =============================================================================
   Papiere aus den offiziellen GoodNotes-Vorlagen

   Die PDFs liegen unter goodnotes-vorlagen/goodnotes-original/. Die Maße hier
   sind daraus abgelesen, in pt wie im PDF (A4 = 595,28 x 841,89 pt), von oben
   gemessen, jeweils die Mitte der 0,5 pt dicken Linie.

   Linien, Kariert und Blanko (die ursprünglichen Papiere in Home.js) stehen
   bewusst nicht hier: für sie bleibt alles, wie es war. Nur wenn eine dieser
   Vorlagen gewählt ist, richten sich Zeilenabstand, Schriftgrösse und Laufweite
   nach dem Papier.

   Dieselben Maße stehen in goodnotes-vorlagen/bauen.py (PDF für GoodNotes).
   ========================================================================== */

/* CSS-Pixel je pt: die App rechnet auf 794 px Seitenbreite */
export const PT = 794 / 595.2756;

/* Bezugsgrösse: der Zeilenabstand der ursprünglichen Papiere in Home.js.
   Laufweite und Zitterbewegung der Zeichen sind darauf geeicht und werden
   im Verhältnis dazu mitskaliert. */
const ZEILE_ORIGINAL = 35;

export const LINIE_FARBE = "#d0d2d3"; // 0,816 0,824 0,827 im PDF
export const RANDLINIE_FARBE = "#c13343"; // 0,757 0,2 0,263 im PDF

export const GN_PAPIERE = {
  gnLiniertEng: {
    name: "Liniert eng",
    linien: { erste: 50.25, abstand: 17.5, anzahl: 45, x0: 0, x1: 595.28 },
  },
  gnLiniertEngRand: {
    name: "Liniert eng mit Seitenrand",
    linien: { erste: 50.25, abstand: 17.5, anzahl: 45, x0: 30, x1: 565.28 },
  },
  gnLiniertRandlinie: {
    name: "Liniert sehr eng mit Randlinie",
    linien: { erste: 50.25, abstand: 16, anzahl: 49, x0: 0, x1: 595.28 },
    randlinie: 64.25,
    /* Text rechts der roten Linie beginnen lassen (75 pt = 100 px) */
    textLinks: 75,
  },
  gnLiniertWeit: {
    name: "Liniert weit",
    linien: { erste: 49.75, abstand: 25, anzahl: 32, x0: 0, x1: 595.28 },
  },
  gnKariert: {
    name: "Kariert groß",
    /* Wie beim ursprünglichen Kariert: eine Schreibzeile ist zwei Kästchen hoch */
    kaestchen: { erste: 15.75, abstand: 16, jeZeile: 2 },
  },
};

/* Alles, was Home.js und der GoodNotes-Export über ein Papier wissen müssen,
   in CSS-Pixeln der A4-Seite (794 x 1123). `rand` ist der obere Seitenrand
   des Textkastens (MARGIN in Home.js). */
export function papierMasse(schluessel, rand) {
  const p = GN_PAPIERE[schluessel];
  if (!p) return null;

  const waagrecht = [];
  const senkrecht = [];
  let zeile;
  let raster;
  let schreiblinien;

  if (p.linien) {
    const { erste, abstand, anzahl, x0, x1 } = p.linien;
    zeile = abstand * PT;
    raster = zeile;
    schreiblinien = [];
    for (let i = 0; i < anzahl; i++) {
      const y = (erste + i * abstand) * PT;
      schreiblinien.push(y);
      waagrecht.push({ y, x0: x0 * PT, x1: x1 * PT });
    }
  } else {
    const { erste, abstand, jeZeile } = p.kaestchen;
    zeile = abstand * jeZeile * PT;
    raster = abstand * PT;
    schreiblinien = [];
    for (let v = erste; v < 841.89; v += abstand) {
      schreiblinien.push(v * PT);
      waagrecht.push({ y: v * PT, x0: 0, x1: 794 });
    }
    for (let v = erste; v < 595.28; v += abstand) {
      senkrecht.push({ x: v * PT, farbe: LINIE_FARBE });
    }
  }
  if (p.randlinie) senkrecht.push({ x: p.randlinie * PT, farbe: RANDLINIE_FARBE });

  /* Erste Linie unterhalb der Oberkante des Textkastens. Von ihr aus zählt
     schriftMetrik.js die Startlinie, genau wie bei den alten Papieren. */
  const ersteLinie = schreiblinien.find((y) => y >= rand);

  return {
    zeile,
    faktor: zeile / ZEILE_ORIGINAL,
    ersteLinieVomKasten: ersteLinie - rand,
    /* Abstand der Papierlinien, auf die eine Grundlinie fallen kann: bei
       Linien eine Zeile, bei Kästchen ein Kästchen */
    raster,
    textLinks: p.textLinks ? p.textLinks * PT : null,
    waagrecht,
    senkrecht,
  };
}
